function Header({ modelTitle, pageTitle }) {
  return (
    <div className="header">
      <h2>{modelTitle}</h2>
      <h2>{pageTitle}</h2>
      {/* other header content */}
    </div>
  );
}

export default Header;
